import ProgressLoader from './loaderVariants/ProgressLoader';
import StepwiseLoader from './loaderVariants/StepwiseLoader';
import PulseLoader from './loaderVariants/PulseLoader';

const LOADER_TYPES = {
  progress: ProgressLoader,
  stepwise: StepwiseLoader,
  pulse: PulseLoader,
};

const Loader = ({ type = 'pulse' }) => {
  const LoaderComponent = LOADER_TYPES[type] || PulseLoader;
  return <LoaderComponent />;
};

export default Loader;